<template>
  <div class="zl-stripe-table">
    <zl-table
      ref="table"
      :scrollbar="false"
      :class="{ 'show-header': !!list.length && hideHead}"
      :column="column"
      :edit="edit"
      :table-type="tableTypeName"
      :data="list"
      :row-class-name="rowClassName"
      :no-fixed="noFixed"
      v-bind="$attrs"
      :[operation]="$operation"
      v-on="$listeners"
    >
      <template slot="link" slot-scope="{ row, index, value, item }">
        <el-link type="primary" @click="$emit('on-link', { row, index, value })">
          {{ item.format ? item.format({ index, value: row[item.prop], row }) : row[item.prop] === undefined ? '' : row[item.prop] }}
        </el-link>
      </template>
    </zl-table>
  </div>
</template>

<script>
import ZlTable from '@utils/table/components/table'
export default {
  componentName: 'StripeTable',
  components: {
    ZlTable
  },
  props: {
    noFixed: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line
    $table: {
      type: Object,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => []
    },
    customColumn: {
      type: Array,
      default: () => []
    },
    // eslint-disable-next-line
    $operation: {},
    hideHead: {
      type: Boolean,
      default: true
    },
    detail: {
      type: Boolean,
      default: false
    },
    // eslint-disable-next-line
    tableType: {}
  },
  computed: {
    operation() {
      return '$operation'
    },
    tableColumn() {
      return this.$table.column
    },
    colomnRules() {
      if (this.detail) return []
      return this.$store.getters.colomnRules[this.$route.name]
    },
    allColumn() {
      return [...this.tableColumn, ...this.customColumn]
    },
    columnMap() {
      return new Map(this.allColumn.map(i => [i.prop, i]))
    },
    column() {
      if (!this.colomnRules || !this.colomnRules.length) return this.allColumn
      const column = []
      this.colomnRules.forEach(i => {
        const item = this.columnMap.get(i.p)
        if (item && i.h !== 1) column.push({ ...item, fixed: this.noFixed ? false : i.f })
      })
      return column
    },
    edit() {
      return this.detail ? false : this.$table._edit
    },
    tableTypeName() {
      return this.detail ? this.tableType : this.$table._type
    },
    rowClassName() {
      return this.$table._rowClassName
    }
  },
  watch: {
    list() {
      this.updateData()
    }
  },
  mounted() {
    this.updateData()
    this.$on('StripeTable.refreshHeight', () => {
      this.updateData()
    })
  },
  methods: {
    validate(callback) {
      this.$refs.table.validate(callback)
    },
    validateCell(index, props, callback) {
      this.$refs.table.validateCell(index, props, callback)
    },
    updateData() {
      if (!this.$el) return
      this.$nextTick(() => {
        this.setCellsHeight()
      })
    },
    setCellsHeight() {
      this.$el.classList.add('updating')
      const trs = this.$el.querySelectorAll('.el-table__body tr.el-table__row')
      trs.forEach(node => {
        const height = node.clientHeight - 16
        node.querySelectorAll('td .cell').forEach(cell => {
          cell.style.height = `${height}px`
        })
      })
      this.$el.classList.remove('updating')
    }
  }
}
</script>

<style lang="scss" scoped>
.zl-stripe-table {
  padding: 0 12px;
  box-sizing: border-box;
  /* 表格无数据居中，max-content会影响宽度 */
  // width: max-content;
  min-width: 100%;
  &.updating /deep/ .el-table tr td .cell {
    height: auto!important;
  }
  /deep/ {
    // 表格样式覆盖
    /* 改变表格宽度 */
    .el-table {
      overflow: unset;
      .el-form-item {
        margin-bottom: 0;
      }
    }
    .show-header {
      &:hover .el-table__header-wrapper{
        display: block;
        padding-bottom: 5px;
        max-height: 100px;
      }
      .el-table__header-wrapper {
        max-height: 0px;
        transition: all .5s;
        padding-bottom: 0px;
      }
    }
    .el-table--small th, .el-table--small td {
      padding: 5px 0;
    }
    .el-table__header-wrapper, .el-table__footer-wrapper {
      overflow: unset;
    }
    /* 去除表格边框线 */
    .el-table th.is-leaf, .el-table td {
      border: none;
    }
    .el-table--group::after, .el-table--border::after, .el-table::before {
      display: none;
    }
    .el-table__fixed::before, .el-table__fixed-right::before {
      display: none;
    }
    /* 重绘表格边框线 */
    .el-table tr td .cell {
      display: flex;
      align-items: center;
      padding: 8px;
      border-bottom: 1px solid #EBEEF5;
      border-top: 1px solid #EBEEF5;
      box-sizing: border-box;
      min-height: 41px;
    }
    .el-table tr td:first-of-type .cell {
      border-left: 1px solid #EBEEF5;
    }
    .el-table tr td:last-of-type .cell {
      border-right: 1px solid #EBEEF5;
    }

    /* 背景颜色修改 */
    .el-table__body tr.hover-row.current-row>td,
    .el-table__body tr.hover-row.el-table__row--striped.current-row>td,
    .el-table__body tr.hover-row.el-table__row--striped>td,
    .el-table__body tr.hover-row>td{
      background-color: transparent;
    }
    .el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: transparent;
    }
    .el-table__body tr.hover-row.current-row > td .cell,
    .el-table__body tr.hover-row.el-table__row--striped.current-row > td .cell,
    .el-table__body tr.hover-row.el-table__row--striped > td .cell,
    .el-table__body tr.hover-row > td .cell {
      // background-color: #F5F7FA;
      border-color: #008EE3;
    }
    .el-table--enable-row-hover .el-table__body tr:hover > td .cell {
      // background-color: #F5F7FA;
      border-color: #008EE3;
    }
  }
}
</style>
